import IndexingFilter from './IndexingFilters';
import IndexingHeader from './IndexingHeader';

interface IIndexDetails {
  title: string;
  skipApiBannerValidation?: boolean;
}
const IndexOverView = (props: IIndexDetails) => {
  const {title, skipApiBannerValidation = false} = props;
  return (
    <div>
      <IndexingHeader title={title} />
      <div className="index-filter-table">
        <IndexingFilter skipApiBannerValidation={skipApiBannerValidation} />
      </div>
    </div>
  );
};

export default IndexOverView;
